{
    "Accessibility Menu": "Menu prístupnosti",
    "Reset settings": "Obnoviť nastavenia",
    "Close": "Zavrieť",
    "Content Adjustments": "Nastavenia obsahu",
    "Adjust Font Size": "Prispôsobiť veľkosť písma",
    "Highlight Title": "Zvýrazniť nadpis",
    "Highlight Links": "Zvýrazniť odkazy",
    "Readable Font": "Čitateľné písmo",
    "Color Adjustments": "Nastavenia farieb",
    "Dark Contrast": "Tmavý kontrast",
    "Light Contrast": "Svetlý kontrast",
    "High Contrast": "Vysoký kontrast",
    "High Saturation": "Vysoká saturácia",
    "Low Saturation": "Nízka saturácia",
    "Monochrome": "Monochromatické",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Vizuálne a navigačné pomôcky",
    "Additional Tools": "Ďalšie nástroje",
    "Reading Guide": "Sprievodca čítaním",
    "Stop Animations": "Zastaviť animácie",
    "Big Cursor": "Veľký kurzor",
    "Screen Reader": "Čítačka obrazovky",
    "Hide Images": "Skryť obrázky",
    "Image Tooltips": "Tipy k obrázkom",
    "Page Structure": "Štruktúra stránky",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupa",
    "Increase Font Size": "Zväčšiť veľkosť písma",
    "Decrease Font Size": "Zmenšiť veľkosť písma",
    "Letter Spacing": "Rozostup písmen",
    "Line Height": "Výška riadku",
    "Font Weight": "Tlak písma",
    "Dyslexia Font": "Písmo pre dyslexiu",
    "Language": "Jazyk",
    "Open Accessibility Menu": "Otvoriť menu prístupnosti",
    "Accessibility Profiles": "Profily prístupnosti",
    "Seizure Safe Profile": "Bezpečný profil pre epileptikov",
    "Stops animations and reduces color saturation.": "Zastaví animácie a zníži sýtosť farieb.",
    "Blind Profile": "Profil pre nevidiacich",
    "Activates the screen reader for auditory navigation.": "Aktivuje čítačku obrazovky pre zvukovú navigáciu.",
    "Visually Impaired Profile": "Profil pre slabozrakých",
    "Enhances contrast and readability for low vision.": "Zlepšuje kontrast a čitateľnosť pre slabozrakých.",
    "ADHD Friendly Profile": "Profil pre ADHD",
    "Reduces distractions for better focus.": "Znižuje rozptyľovanie pre lepšiu koncentráciu.",
    "Cognitive & Learning Profile": "Kognitívny a vzdelávací profil",
    "Helpful tools for reading and comprehension.": "Užitočné nástroje na čítanie a porozumenie.",
    "Motor Impaired Profile": "Profil pre pohybové postihnutie",
    "Optimizes the site for keyboard-only navigation.": "Optimalizuje stránku pre navigáciu iba klávesnicou.",
    "Headings": "Nadpisy",
    "Landmarks": "Orientačné body",
    "Links": "Odkaze",
    "Focus element": "Zamerať prvok",
    "Visit link": "Navštíviť odkaz"
}
